/*function SkillProgress({ skill, percentage }) {
  return (
    <div className="mb-4">
      {" "}
      <div className="flex justify-between mb-1">
        {" "}
        <span className="text-gray-900 dark:text-gray-200 font-semibold">
          {skill}
        </span>{" "}
        <span className="text-gray-600 dark:text-gray-400">{percentage}%</span>{" "}
      </div>{" "}
      <div className="w-full bg-gray-200 dark:bg-gray-600 rounded-full h-4">
        {" "}
        <div
          className="bg-blue-600 dark:bg-blue-400 h-4 rounded-full transition-all duration-500"
          style={{ width: `${percentage}%` }}
        ></div>{" "}
      </div>{" "}
    </div>
  );
}
export default SkillProgress;
*/
function SkillProgress({ skill, percentage }) {
  const radius = 40;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;
  return (
    <div className="flex items-center mb-4 ">
      {" "}
      <div className="relative w-20 h-20">
        {" "}
        <svg className="w-full h-full" viewBox="0 0 100 100">
          {" "}
          {/* Cercle de fond */}{" "}
          <circle
            className="text-gray-300 dark:text-gray-600"
            strokeWidth="10"
            stroke="currentColor"
            fill="transparent"
            r={radius}
            cx="50"
            cy="50"
          />{" "}
          {/* Cercle de progression */}{" "}
          <circle
            className="text-blue-600 dark:text-blue-400"
            strokeWidth="10"
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            strokeLinecap="round"
            stroke="currentColor"
            fill="transparent"
            r={radius}
            cx="50"
            cy="50"
          />{" "}
        </svg>{" "}
        <span className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-blue-600 dark:text-gray-200 font-semibold">
          {" "}
          {percentage}%{" "}
        </span>{" "}
      </div>{" "}
      <span className="ml-4 text-blue-600 dark:text-gray-200 font-semibold ">
        {skill}
      </span>{" "}
    </div>
  );
}
export default SkillProgress;
